export default __webpack_public_path__ + "static/media/payattable.2e7c5076.yaml";